import {get, post, put, _delete} from './Tools';

const getHeaders = async (tipo_periodo, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}recibo_nomina/${tipo_periodo}/${anio}/${num_periodo}`);
  return response;
};

const getDetails = async (odoo_empleado_id, tipo_periodo, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}recibo_nomina/${odoo_empleado_id}/${tipo_periodo}/${anio}/${num_periodo}`);
  return response;
};

const getTotals = async (tipo_periodo, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}recibo_nomina/get/totales/${tipo_periodo}/${anio}/${num_periodo}`);
  return response;
};

const importBulk = async (file, periodo_id, anio, num_periodo, force_save = false) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('periodo_id', periodo_id);
  formData.append('anio', anio);
  formData.append('num_periodo', num_periodo);
  formData.append('force_save', force_save ? 1 : 0);
  
  const token = localStorage.getItem('token');
  
  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}recibo_nomina/import`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
      },
      body: formData,
    });
    
    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

const importBulkConfirm = async (periodo_id, anio, num_periodo, cached_records) => {
  const token = localStorage.getItem('token');
  
  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}recibo_nomina/import/confirm`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        periodo_id,
        anio,
        num_periodo,
        cached_records
      }),
    });
    
    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

const deleteImported = async (periodo_id, anio, num_periodo) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}recibo_nomina/importados/${periodo_id}/${anio}/${num_periodo}`);
  return response;
};

export { getHeaders, getDetails, getTotals, importBulk, importBulkConfirm, deleteImported };
